import { Box, Grid, Tooltip, Typography, useTheme } from '@mui/material'
import ListItemButton from '@mui/material/ListItemButton';
import { DescriptionOutlined, ImageOutlined, OpenInNew, PictureAsPdfOutlined, ViewInArOutlined } from '@mui/icons-material';
import ListItemText from '@mui/material/ListItemText';

const styles = {
    filesText: {
        fontWeight: 600,
},
    fileContainer: {
        border: '2px solid',
        borderColor: 'var(--spectre-border)',
        mt: .5
    }
}

export default function FilePath(props: any) {
    const { path, rawPath } = props
    const theme = useTheme();

    const fileName = rawPath?.split('/').pop() || path.split('/').pop() || path;
    const extension = fileName.split('.').pop()?.toLowerCase();
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension || '');
    const icon = extension === 'pdf'
        ? <PictureAsPdfOutlined />
        : extension === 'pcd'
            ? <ViewInArOutlined />
            : isImage
                ? <ImageOutlined />
                : <DescriptionOutlined />;
    const accentColor = extension === 'xml'
        ? theme.palette.spectre.fileAccentXml
        : extension === 'pcd'
            ? theme.palette.spectre.fileAccentPcd
            : isImage
                ? theme.palette.spectre.fileAccentImage
                : theme.palette.spectre.fileAccentDefault;

    return (
        <Grid item xs={12} sm={6}>
            <ListItemButton
                component="a"
                href={path}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    alignItems: 'center',
                    backgroundColor: 'var(--spectre-file-card-surface)',
                    border: '1px solid var(--spectre-border)',
                    borderRadius: 1,
                    gap: 1.5,
                    minHeight: 76,
                    px: 1.5,
                    py: 1.25,
                    '&:hover': {
                        borderColor: accentColor,
                        backgroundColor: 'var(--spectre-file-card-surface-hover)',
                    },
                }}
            >
                <Box
                    sx={{
                        alignItems: 'center',
                        backgroundColor: `${accentColor}18`,
                        border: `1px solid ${accentColor}55`,
                        borderRadius: 1,
                        color: accentColor,
                        display: 'flex',
                        flex: '0 0 auto',
                        height: 46,
                        justifyContent: 'center',
                        width: 46,
                    }}
                >
                    {icon}
                </Box>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography color="text.primary" fontWeight={600} noWrap title={fileName}>
                        {fileName}
                    </Typography>
                    <Typography color="text.secondary" sx={{ fontSize: '0.75rem', textTransform: 'uppercase' }}>
                        {extension || 'file'}
                    </Typography>
                </Box>
                <Tooltip title="Open file">
                    <OpenInNew color="action" fontSize="small" />
                </Tooltip>
            </ListItemButton>
        </Grid>
    )
}